import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import { Root } from '@/api/helpers/get-current-user'

export const mockGetCompanies = http.get(
  '/my-business/api/agency/v1/company-infos/list',
  async () => {
    const travelAgencies: Root['data'] = Array.from({ length: 20 }).map(() => ({
      active: true,
      alphaId: faker.string.uuid(),
      parentAlphaId: faker.string.uuid(),
      companyChainProfileData: {
        companyChainClassification: faker.helpers.arrayElement([
          'BASIC',
          'SMART',
        ]),
        companyChainProfileStatusEnum: 'RELEASED',
        companyChainType: 'AGENCY',
        observation: faker.lorem.sentence(),
      },
      companyTypeCode: 'TRAVEL_AGENCY',
      legalData: {
        corporateName: faker.company.name(),
        municipalRegistration: '',
        name: faker.company.name(),
        observation: '',
        stateRegistration: '',
        taxpayerId: faker.string.numeric(14),
      },
      addressData: {
        address: faker.location.streetAddress(),
        complement: faker.lorem.word(),
        number: faker.string.numeric(2),
        zipcode: faker.location.zipCode(),
      },
      contactData: {
        companyEmail: faker.internet.email(),
        companyPhone: faker.phone.number(),
        name: faker.person.fullName(),
      },
      contracts: {
        b2bContract: faker.internet.url(),
        socialContract: faker.internet.url(),
      },
      released: 'true',
      responsibleData: {
        companyPosition: faker.person.jobTitle(),
        name: faker.person.fullName(),
        responsibleTaxpayerId: faker.string.numeric(11),
      },
    }))

    const pointOfSales: Root['data'] = Array.from({ length: 20 }).map(() => ({
      active: true,
      alphaId: faker.string.uuid(),
      parentAlphaId: faker.helpers.arrayElement(
        travelAgencies.map((each) => each.alphaId),
      ),
      companyChainProfileData: {
        companyChainClassification: faker.helpers.arrayElement([
          'BASIC',
          'SMART',
        ]),
        companyChainProfileStatusEnum: 'RELEASED',
        companyChainType: 'AGENCY',
        observation: faker.lorem.sentence(),
      },
      companyTypeCode: 'POS',
      legalData: {
        corporateName: faker.company.name(),
        municipalRegistration: '',
        name: faker.company.name(),
        observation: '',
        stateRegistration: '',
        taxpayerId: faker.string.numeric(14),
      },
      addressData: {
        address: faker.location.streetAddress(),
        complement: faker.lorem.word(),
        number: faker.string.numeric(2),
        zipcode: faker.location.zipCode(),
      },
      contactData: {
        companyEmail: faker.internet.email(),
        companyPhone: faker.phone.number(),
        name: faker.person.fullName(),
      },
      contracts: {
        b2bContract: faker.internet.url(),
        socialContract: faker.internet.url(),
      },
      released: 'true',
      responsibleData: {
        companyPosition: faker.person.jobTitle(),
        name: faker.person.fullName(),
        responsibleTaxpayerId: faker.string.numeric(11),
      },
    }))

    const response: Root = {
      timestamp: faker.date.recent().toISOString(),
      data: [
        {
          alphaId: faker.string.uuid(),
          active: true,
          released: 'true',
          addressData: {
            address: faker.lorem.words(),
            complement: faker.lorem.words(),
            number: faker.string.numeric(2),
            zipcode: '95040-420',
          },
          companyTypeCode: faker.helpers.arrayElement(['AGENCY_CHAIN']),
          contactData: {
            companyEmail: faker.internet.email(),
            name: faker.person.fullName(),
            companyPhone: faker.phone.number(),
          },
          legalData: {
            corporateName: faker.company.name(),
            municipalRegistration: '',
            name: faker.company.name(),
            observation: faker.lorem.sentence(),
            stateRegistration: '',
            taxpayerId: faker.string.numeric(14),
          },
          responsibleData: {
            name: faker.person.fullName(),
            responsibleTaxpayerId: faker.string.numeric(11),
            companyPosition: faker.person.jobTitle(),
          },
          contracts: {
            b2bContract: faker.internet.url(),
            socialContract: faker.internet.url(),
          },
          companyChainProfileData: {
            companyChainClassification: faker.helpers.arrayElement([
              'A',
              'B',
              'C',
              'D',
            ]),
            companyChainProfileStatusEnum: faker.helpers.arrayElement([
              // 'RELEASED',
              // 'CREATED',
              'STARTED',
            ]),
            companyChainType: faker.helpers.arrayElement([
              'CHAIN',
              'FRANCHISE',
            ]),
            observation: faker.lorem.sentence(),
          },
        },
        ...travelAgencies,
        ...pointOfSales,
      ],
    }

    return HttpResponse.json(response, { status: 200 })
  },
)
